"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _x = _interopRequireDefault(require("country-flag-icons/react/3x2"));
var _CountryList = _interopRequireDefault(require("./CountryList"));
var _CountryFlag = require("./CountryFlag.style");
const CountryFlag = _ref => {
  let {
    countryName,
    fit = 'medium'
  } = _ref;
  const validCountryName = !!countryName && countryName.split(',').reverse().join(' ').trim().toLowerCase();
  const countryCode = !!validCountryName && (Object.values(_CountryList["default"]).includes(countryName) && countryName || _CountryList["default"][validCountryName]);
  const Flag = !!countryCode && _x["default"][countryCode];
  return Flag ? (0, _jsxRuntime.jsx)(_CountryFlag.StyledCountryFlag, (0, _extends2["default"])({
    fit: fit
  }, {
    children: (0, _jsxRuntime.jsx)(Flag, {})
  })) : (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};
var _default = exports["default"] = CountryFlag;